import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { SolStorageService } from './sol-storage.service';
import { SolUrls } from './sol-urls';
import { SolApiResponse } from './sol-api-response';
import { throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';

@Injectable()
export class SolApiService {
  // Calling Urls Class...
  urls: SolUrls = new SolUrls();

  constructor(private http: HttpClient, public state: SolStorageService) { }

  /*
  POST Function:
  Token: boolean true to append token, false to POST without token.
  functionKey: string hold the API Function that we need to hit.
  headerData: holds the values for submission.
  Returns: API Call response.
  */
  public post(token = true, functionKey, headerData) {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${this.state.getItem(`token`)}`
    });
    if (token) {
      return this.http
        .post<SolApiResponse>(this.urls.getFunction(functionKey), headerData, { headers: headers })
        .pipe(
          // retry(3), // retry a failed request up to 3 times
          catchError(this.handleError) // then handle the error
        );
    } else {
      if (!headerData) {
        headerData = [];
      }
      return this.http
        .post<SolApiResponse>(this.urls.getFunction(functionKey), headerData)
        .pipe(
          // retry(3), // retry a failed request up to 3 times
          catchError(this.handleError) // then handle the error
        );
    }
  }
  public put(token = true, functionKey, headerData) {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${this.state.getItem(`token`)}`
    });
    if (token) {
      return this.http
        .put<SolApiResponse>(this.urls.getFunction(functionKey), headerData, { headers: headers })
        .pipe(
          // retry(3), // retry a failed request up to 3 times
          catchError(this.handleError) // then handle the error
        );
    } else {
      if (!headerData) {
        headerData = [];
      }
      return this.http
        .put<SolApiResponse>(this.urls.getFunction(functionKey), headerData)
        .pipe(
          // retry(3), // retry a failed request up to 3 times
          catchError(this.handleError) // then handle the error
        );
    }
  }
  public get(token = true, functionKey, headerData,type?) {
    if (token) {
      if (!headerData) {
        return this.http
          .get<SolApiResponse>(
            this.urls.getFunction(functionKey) + '?' + headerData
          )
          .pipe(
            // retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
          );
      } else {
        headerData += '&token=' + this.state.getItem('token');
        return this.http
          .get<SolApiResponse>(
            this.urls.getFunction(functionKey) + '?' + headerData
          )
          .pipe(
            // retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
          );
      }
    } else {
      if(type == 'param'){
        return this.http
        .get<SolApiResponse>(
          this.urls.getFunction(functionKey) + '/' + headerData
        )
        .pipe(
          // retry(3), // retry a failed request up to 3 times
          catchError(this.handleError) // then handle the error
        );
      } else {
        return this.http
        .get<SolApiResponse>(
          this.urls.getFunction(functionKey) + '?' + headerData
        )
        .pipe(
          // retry(3), // retry a failed request up to 3 times
          catchError(this.handleError) // then handle the error
        );
      }
        
    }
  }

  public uploadFile(file, folder) {
    const formData: FormData = new FormData();
    if (file.length > 1) {
      for (const fil of file) {
        formData.append('attachment', fil);
      }
    } else if (file.length === 1) {
      formData.append('attachment', file[0]);
    }
    formData.append('path', folder);
    this.state.setItem('token', 2934823423423423423423);
    formData.append('token', this.state.getItem('token').toString());
    return this.http.post<SolApiResponse>(
      this.urls.getUploadsUrl(folder),
      formData
    );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      return throwError(error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      return throwError(error.message);
    }
    // return an observable with a user-facing error message
    return throwError('Something bad happened; please try again later.');
  }
}
